import { Certificate } from '@peculiar/asn1-x509';
import {
  SubjectAlternativeNameExtension,
  X509Certificate,
} from '@peculiar/x509';

export const decodeCertificate = (pemCert: Certificate) => {
  try {
    const cert = new X509Certificate(pemCert);

    const extractCommonNames = (dnString: string) =>
      dnString
        .split(',')
        .map(part => part.trim())
        .filter(part => part.startsWith('CN='))
        .map(cn => cn.replace('CN=', ''));

    // Get Common Names from both subject and issuer
    const subjectCNs = extractCommonNames(cert.subject);
    const issuerCNs = extractCommonNames(cert.issuer);

    // Get SAN extension
    const sanExtension = cert.getExtension(SubjectAlternativeNameExtension);

    // Extract DNS names
    const dnsNames = sanExtension?.names.items
      .filter(name => name.type === 'dns')
      .map(name => name.value);

    return {
      subjectCommonNames: subjectCNs,
      issuerCommonNames: issuerCNs,
      subject: cert.subject,
      issuer: cert.issuer,
      validFrom: cert.notBefore,
      validTo: cert.notAfter,
      serialNumber: cert.serialNumber,
      dnsNames: dnsNames || [],
    };
  } catch (error) {
    console.error('Failed to decode certificate:', error);
    return null;
  }
};
